var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCozResourceLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "317px",
    height: "34px",
    viewBox: "0 0 319 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Title") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "-1440-desktop-designs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop--1440-Homepage",
    transform: "translate(-175.000000, -24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header",
    transform: "translate(-1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Title",
    transform: "translate(176.070004, 24.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(17.423999, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(1.369922, 9.321231)",
    stroke: "#7D9FB1",
    strokeWidth: 1.04635715
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    x: 0.655155736,
    y: 0.542907914,
    width: 65.9214143,
    height: 19.0882066
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(10.490277, 11.413000) rotate(-316.000000) translate(-10.490277, -11.413000) translate(3.798370, 3.359175)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#7D9FB1",
    strokeWidth: 0.5,
    fill: "#7D9FB1",
    fillRule: "nonzero",
    points: "61.0846507 14.7969302 61.0846507 16.3902347 55.2683231 22.2655452 61.0846507 22.2655452 61.0846507 24.0978454 52.8335214 24.0978454 52.8335214 22.5045409 58.6105364 16.6491467 53.1531778 16.6491467 53.1531778 14.7969302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3882304,14.6160138 C46.9789402,14.6160138 49.2113605,16.8432112 49.2113605,19.4278599 C49.2113605,22.0125087 46.9789402,24.2397061 44.3882304,24.2397061 C41.7975205,24.2397061 39.5651002,22.0125087 39.5651002,19.4278599 C39.5651002,16.8432112 41.7975205,14.6160138 44.3882304,14.6160138 Z M44.3882304,16.6644855 C42.9412913,16.6644855 41.632156,17.970558 41.632156,19.4141118 C41.632156,20.8576656 42.9412913,22.1774863 44.3882304,22.1774863 C45.8351694,22.1774863 47.1443047,20.8576656 47.1443047,19.4141118 C47.1443047,17.970558 45.8351694,16.6644855 44.3882304,16.6644855 Z",
    id: "Combined-Shape",
    fill: "#7D9FB1",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3727603,20.9319307 L35.6740824,20.9319307 C35.0401853,22.8566691 33.2211762,24.2452304 31.0852186,24.2452304 C28.4256068,24.2452304 26.2620885,22.0867737 26.2620885,19.4333843 C26.2620885,16.7799949 28.4256068,14.6215382 31.0852186,14.6215382 C33.2211762,14.6215382 35.0264049,15.9963514 35.660302,17.9073417 L33.3589799,17.9073417 C32.9731295,17.0687056 32.0360642,16.5462766 31.0852186,16.5462766 C29.5693777,16.5462766 28.356705,17.8523491 28.356705,19.4333843 C28.356705,21.0281676 29.5693777,22.320492 31.0852186,22.320492 C32.0498446,22.320492 32.9869099,21.7568186 33.3727603,20.9319307 Z",
    id: "Path",
    stroke: "#7D9FB1",
    strokeWidth: 0.5,
    fill: "#7D9FB1",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9731028,9.24092306 L21.3215834,29.2948971 L1.69154274,29.6390759 L1.34306213,9.58510184 L20.9731028,9.24092306 Z M5.88033947,16.7972267 L4.07132937,18.6705115 L7.78108442,22.2527408 L4.16355881,26.0000276 L7.82769373,25.918216 L11.4457139,22.1716464 L5.88033947,16.7972267 Z M16.8251072,20.2454914 L13.2469339,23.9551072 L16.858885,23.8958666 L18.6808913,21.982039 L16.8251072,20.2454914 Z M13.1401507,12.9668039 L11.3305935,14.8393208 L9.47601576,13.0486155 L7.66700566,14.9219003 L13.2323801,20.2963199 L15.0413902,18.4230351 L13.1857708,16.6308448 L14.9952755,14.7582771 L13.1401507,12.9668039 Z",
    id: "Combined-Shape",
    fill: "#7D9FB1",
    transform: "translate(11.332323, 19.439999) rotate(1.000000) translate(-11.332323, -19.439999) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(95.435995, 14.148000)",
    fill: "#7D9FB1",
    fontWeight: 500,
    fontSize: 14.2559993,
    letterSpacing: 0.972913421
  }, /*#__PURE__*/React.createElement("text", {
    id: "NEO-blockchain-resou"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 14
  }, "NEO BLOCKCHAIN RESOURCE"))), /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    transform: "translate(0.000000, 14.148000)",
    fill: "#7D9FB1",
    fontWeight: 500,
    fontSize: 14.2559993,
    letterSpacing: 0.972913421
  }, /*#__PURE__*/React.createElement("text", {
    id: "A"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0.39599998,
    y: 14
  }, "A")))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCozResourceLogo);
export default __webpack_public_path__ + "static/media/coz-resource-logo.23716b79.svg";
export { ForwardRef as ReactComponent };